// ManagedContentModel documents (About Us, How To Order, policies, footer
// text/contact info, email templates, etc.) exist per language, but a
// language's document commonly has some fields left blank because nobody
// has translated that specific section yet. Unlike the medicine/blog
// lists (which upsert whole records), this is a single settings document,
// so the right fallback is field-by-field: use the target language's
// value wherever it's actually filled in, and fall back to English's
// value field-by-field otherwise.
function isEmptyValue(value) {
  if (value === undefined || value === null || value === "") return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
}

// Arrays are treated as atomic (not merged item-by-item, since item order/
// shape isn't guaranteed to correspond between languages) — an empty
// array falls back to English's, a non-empty one is used as-is.
function mergeValue(enValue, otherValue) {
  if (otherValue === undefined) return enValue;
  if (enValue === undefined) return otherValue;

  if (Array.isArray(enValue) || Array.isArray(otherValue)) {
    return isEmptyValue(otherValue) ? enValue : otherValue;
  }

  if (
    enValue &&
    otherValue &&
    typeof enValue === "object" &&
    typeof otherValue === "object"
  ) {
    const merged = {};
    const keys = new Set([...Object.keys(enValue), ...Object.keys(otherValue)]);
    keys.forEach((key) => {
      merged[key] = mergeValue(enValue[key], otherValue[key]);
    });
    return merged;
  }

  return isEmptyValue(otherValue) ? enValue : otherValue;
}

// Returns the managed-content document for `langId`, with any blank field
// (at any depth) filled in from the English document. `langs` is the
// state.misc langs list, used to resolve which document is English's.
export function mergeManagedContent(managedContentSettings, langId, langs) {
  if (!managedContentSettings || managedContentSettings.length === 0) return {};

  const englishLangId = (langs || []).find((l) => l.langCode === "en")?._id;

  const enDoc = managedContentSettings.find((m) => m.langId === englishLangId);
  if (!enDoc) return {};

  if (!langId || langId === englishLangId) return enDoc;

  const doc = managedContentSettings.find((m) => m.langId === langId);
  if (!doc) return enDoc;

  return mergeValue(enDoc, doc);
}
